import { apiRequest } from "../../shared/api/client";
import { workOrderReportSchema, workOrderDetailSchema, type WorkOrderQuery } from "../../../shared/production-work-orders/contracts";
const endpoint = "/api/integrations/production/mikro/work-orders";
export async function fetchWorkOrders(query: WorkOrderQuery, signal: AbortSignal) {
  return workOrderReportSchema.parse(await apiRequest<unknown>(`${endpoint}?${new URLSearchParams({ ...query, page: String(query.page), offset: String(query.offset) })}`, { signal, cache: "no-store" }));
}
export async function fetchWorkOrderMovements(workOrderNo: string, productCode: string, signal: AbortSignal) {
  return workOrderDetailSchema.parse(await apiRequest<unknown>(`${endpoint}/movements?${new URLSearchParams({ workOrderNo, productCode })}`, { signal, cache: "no-store" }));
}
